import { useParams, useNavigate } from 'react-router-dom';
import { Button, Spin, Alert } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined } from '@ant-design/icons';

const token = () => localStorage.getItem('ar_token');

export default function SignDocViewPage() {
  const { orderNo } = useParams();
  const navigate = useNavigate();
  
  const pdfUrl = `/api/arrival/view-pdf/${orderNo}?token=${token()}`;
  const downloadUrl = `/api/arrival/download-pdf/${orderNo}?token=${token()}`;

  return (
    <div style={{ height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>返回</Button>
        <a href={downloadUrl} target="_blank">
          <Button type="primary" icon={<DownloadOutlined />}>下载签收单</Button>
        </a>
      </div>
      <div style={{ flex: 1, border: '1px solid #e8e8e8', borderRadius: 4, overflow: 'hidden' }}>
        <embed src={pdfUrl} type="application/pdf" style={{ width: '100%', height: '100%', border: 'none' }} />
      </div>
    </div>
  );
}
